module.exports = __webpack_public_path__ + "img/10-7.d4d4d7da.png";